import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export enum VerificationType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

interface Payload {
  value: string,
  type: VerificationType,
  is_link: boolean,
  contact_id: string
}

const useSendVerificationCodeForContactQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) => api.post(API_URL.CONTACTS_VERIFICATION_CODES, payload));

  return {
    sendVerificationCodeForContact: mutateAsync,
    isSendCodeLoading: isLoading,
  };
};

export default useSendVerificationCodeForContactQuery;
